import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

export const BUSINESS_OWNER = 'BUSINESS_OWNER';

const cyPrefix = 'page_application_overview';

const storeDetailsIds = {
  BUSINESS_ADDRESS_BLOCK: 'BUSINESS_ADDRESS_BLOCK',
  COMPANY_NAME: 'COMPANY_NAME',
  COUNTRY: 'COUNTRY',
  EMAIL: 'EMAIL',
  GOODS_CATEGORY: 'GOODS_CATEGORY',
  OPERATING_ADDRESS_BLOCK: 'OPERATING_ADDRESS_BLOCK',
  ORGANIZATION_ENTITY_TYPE: 'ORGANIZATION_ENTITY_TYPE',
  REGISTRATION_ID: 'REGISTRATION_ID',
  STORE_NAME: 'STORE_NAME',
  TOC: 'TOC',
  VAT_ID: 'VAT_ID',
  WEBSITE: 'WEBSITE',
};

const bankAccountIds = {
  ACCOUNT_HOLDER: 'ACCOUNT_HOLDER',
  ACCOUNT_NUMBER: 'ACCOUNT_NUMBER',
  BANK_ACCOUNT_BLOCK: 'BANK_ACCOUNT_BLOCK',
  BANK_COUNTRY: 'BANK_COUNTRY',
  BIC: 'BIC',
  TRANSIT_NUMBER: 'TRANSIT_NUMBER',
  INSTITUTION_NUMBER: 'INSTITUTION_NUMBER',
  CURRENCY_CODE: 'CURRENCY_CODE',
};

const addressIds = {
  ADDRESS_COUNTRY: 'ADDRESS_COUNTRY',
  CITY: 'CITY',
  POSTAL_CODE: 'POSTAL_CODE',
  REGION: 'REGION',
  STREET: 'STREET',
};

const stakeholderIds = {
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  PERSONAL_ID: 'PERSONAL_ID',
  STAKEHOLDER_BLOCK: 'STAKEHOLDER_BLOCK',
};

const ids = {
  ...addCyPrefixToIDs('store_details', storeDetailsIds),
  ...addCyPrefixToIDs('bank_accounts', bankAccountIds),
  ...addCyPrefixToIDs('address', addressIds),
  ...addCyPrefixToIDs('stakeholder', stakeholderIds),
};

export const CY_APPLICATION_OVERVIEW_PAGE_IDS = addCyPrefixToIDs(cyPrefix, ids);
